import { webCryptoRandom } from '@zaplify/frontend-common';
import * as cheerio from 'cheerio';

export function getRandomColorsWithContrast(): { color: string; backgroundColor: string } {
    const hue = Math.floor(webCryptoRandom() * 360);
    const saturation = Math.floor(webCryptoRandom() * 100);
    const light = Math.floor(webCryptoRandom() * 100);
    const threshold = 65;
    const backgroundColor = `hsl(${hue}, ${saturation}% , ${light}%)`;
    const switchColor = Math.sign(light - threshold) * -100;
    const color = `hsl(0, 0%, ${switchColor}%)`;

    return { color, backgroundColor };
}

export function isNumber(value: any) {
    return typeof value === 'number' || value instanceof Number;
}

export function isString(value: any) {
    return typeof value === 'string' || value instanceof String;
}

const extensionId = import.meta.env.VITE_ZAPLIFY_CHROME_EXTENSION_ID || 'nolanbablkmlhllilaloenjhaplnfhof';

export function importHTML(html: string) {
    const stringCopy = (' ' + html).slice(1);
    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString(stringCopy, 'text/html');
    const formattedString = parsedDocument.documentElement.innerHTML;
    return (' ' + formattedString).slice(1);
}

export function htmlToPlain(html: string) {
    html = html.replace(/<style[^>]*>.*<\/style>/gi, '');
    html = html.replace(/<\/div>/gi, '\n');
    html = html.replace(/<\/li>/gi, '\n');
    html = html.replace(/<li>/gi, '  *  ');
    html = html.replace(/<\/ul>/gi, '\n');
    html = html.replace(/<\/h[1-5]>/gi, '\n');
    html = html.replace(/<\/p>/gi, '\n');
    html = html.replace(/<br.*?>/gi, '\n');
    html = html.replace(/<[^>]+>/gi, '');
    html = html.replace(/&(nbsp|ensp|emsp|emsp13|emsp14|numsp|puncsp|hairsp|MediumSpace|thinsp|);/gi, ' ');

    const $ = cheerio.load(html);
    const root = $.root();
    let text = root.text();
    text = text.replace(/ | | | | | | | | | /gi, ' ').trim();
    return text;
}

type EmailState = 'Email exists' | 'Email missing' | 'Enrichment';

export function getEmailState(email: string | null | undefined): EmailState {
    let emailState: EmailState;
    const emailStatuses = {
        enriching: '...',
        emailIssues: ['none', 'None', '', null],
    };

    if (email && isEmail(email)) {
        emailState = 'Email exists';
    } else if (email === emailStatuses.enriching) {
        emailState = `Enrichment`;
    } else if (email && emailStatuses.emailIssues.includes(email)) {
        emailState = 'Email missing';
    } else {
        emailState = 'Email missing';
    }
    return emailState;
}

const isEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

//Mapping from hash to color
const colors = ['#FF6A76'];

const getHash = (str: string): number => {
    var hash = 0;
    if (!str) return 0;
    if (str.length === 0) return 0;
    for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    hash = ((hash % colors.length) + colors.length) % colors.length;
    return hash;
};

export function stringToColor(str: string) {
    const hash = getHash(str);
    const color = colors[hash];
    return color;
}
